import { Link } from 'react-router-dom'
import ComicCard from '@/components/feature/ComicCard'
import { hotComics, latestUpdates } from '@/mocks/comics'

export default function FeaturedGrid() {
  return (
    <>
      <section className="py-14 md:py-20">
        <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-500 font-medium mb-3">热门推荐</p>
              <h2 className="text-3xl md:text-5xl font-heading text-foreground-900 leading-tight">
                🔥 大家都在看
              </h2>
              <p className="mt-2 text-sm text-foreground-600">精选高分韩漫，口碑之选不容错过</p>
            </div>
            <Link
              to="/category/love"
              className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {hotComics.map((comic) => (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                author={comic.author}
                rating={comic.rating}
                views={comic.views}
                status={comic.status}
                coverImage={comic.coverImage}
                category={comic.category}
                tags={comic.tags}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
            <div>
              <p className="text-xs uppercase tracking-widest text-foreground-500 font-medium mb-3">最新更新</p>
              <h2 className="text-3xl md:text-5xl font-heading text-foreground-900 leading-tight">
                ⚡ 刚刚更新
              </h2>
              <p className="mt-2 text-sm text-foreground-600">追更党必看，第一时间阅读最新章节</p>
            </div>
            <Link
              to="/category/action"
              className="inline-flex items-center gap-1.5 text-sm text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
            >
              查看更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {latestUpdates.map((comic) => (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                author={comic.author}
                rating={comic.rating}
                views={comic.views}
                status={comic.status}
                coverImage={comic.coverImage}
                category={comic.category}
                tags={comic.tags}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  )
}